export enum ExperienceLevel {
  Beginner = 'Beginner',
  Advanced = 'Advanced',
  Intermediate = 'Intermediate',
}

export enum QuickCampaignPlaces {
  FLOW_MODAL = 'flow',
  DEFAULT_REPLY = 'default_reply',
  COLLECT_OPT_INS = 'follow_ups',
  STORY_MENTION_REPLY = 'story_mention_reply',
  WELCOME_MESSAGE = 'welcome_message',
  MAIN_MENU = 'main_menu',
  CONVERSATION_STARTERS = 'conversation_starters',
  DASHBOARD = 'dashboard',
  AI_PROMOTIONS = 'ai_promotions',
  SUGGESTIONS = 'suggestions',
  IG_USERS_VALUE = 'ig_users_value',
  IG_INSIGHTS = 'ig_insights',
}

export enum UseCases {
  REDIRECT_TO_THE_WEBSITE = 'redirect_to_the_website',
  INFORM_ABOUT_PRODUCTS = 'inform_about_products',
  CAPTURE_EMAILS = 'capture_emails',
  CAPTURE_PHONE_NUMBERS = 'capture_phone_numbers',
  ANSWER_FAQ = 'answer_faq',
  SCHEDULE_MEETINGS = 'schedule_meetings',
  INCREASE_ENGAGEMENT = 'increase_engagement',
  NURTURE_LEADS = 'nurture_leads',
  TELL_CUSTOMER_ABOUT_YOUR_BUSINESS = 'tell_customer_about_your_business',
  INTERACT_WITH_YOUR_CUSTOMERS = 'interact_with_your_customers',
  CAPTURE_CUSTOMER_DATA = 'capture_customer_data',
  QUALIFY_YOUR_LEADS = 'qualify_your_leads',
  CGT = 'cgt',
  LIVES = 'lives',
  STORIES = 'stories',
  DM = 'dm',
  OLD = 'old',
  NEW_SUBSCRIBERS = 'new_subscribers',
  FOOD = 'food',
}
